export default __webpack_public_path__ + "static/media/notConnect.67318388.svg";